import React from "react";
// import JudgeAddition from "./JudgeAddition";
import AgeGroupAddition from "./AgeGroupAddition";
import Header from "../judge_settings/header";

const JudgeSettings = () => {
    return (
        <div>
            <Header/>
            <div style={{display: "flex"}}>
                {/* <JudgeAddition/> */}
                <AgeGroupAddition/>
            </div>
        </div>
    );
}

export default JudgeSettings;